import { BaseApiTemplateService, Core2Config } from '../../../shared';
import { ProjectContainerModel } from '../../../../../../../models/aggregates/alg/cc/project/project-container.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ProjectService extends BaseApiTemplateService<ProjectContainerModel> {
  constructor(http: HttpClient) {
    super();

    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ALG_CC_MODULE +
      'projects';

    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ALG_CC_MODULE +
      'projects';

    this.httpClient = http;
  }
}
